export default "__VITE_ASSET__D_hk0upO__"